<ng-container *ngIf="organizationLoadState === 'ready'; else organizationStartup">
  <app-loader [loading]="isLoading"></app-loader>
  <router-outlet></router-outlet>
  <app-profile-modal></app-profile-modal>
  <app-maintenance-alert></app-maintenance-alert>
</ng-container>

<ng-template #organizationStartup>
  <main *ngIf="organizationLoadState === 'error'" class="organization-startup" aria-live="polite">
    <section class="organization-startup__card" aria-labelledby="organization-startup-title">
      <div class="organization-startup__brand">
        <!-- <span>Nora · School Management System.</span> -->
      </div>
        <div class="organization-startup__icon" aria-hidden="true"><i class="bi bi-cloud-slash"></i></div>
        <span class="organization-startup__eyebrow">Service unavailable</span>
        <h1 id="organization-startup-title">We couldn't connect to the server</h1>
        <p>The application couldn't load right now. Please try again in a moment.</p>
        <button type="button" (click)="retryOrganizationLoad()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i> Retry connection</button>
        <p class="organization-startup__hint">We'll take you back to your page once connected.</p>
    </section>
    <footer class="organization-startup__footer">Nora &middot; School Management System</footer>
  </main>
</ng-template>
